// /api/getUsers
import { fetchClass } from "../plugins/fetchAuth.ts";
import { getUrls } from "./apiurls.js";

export function APIgetStores(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  const { fida } = getUrls();
  return fetchClass(
    `${fida}/api/getStores`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {},
    false
  );
}

export function APIgetBrands(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  const { fida } = getUrls();
  return fetchClass(
    `${fida}/api/getStoreBrands`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}

// export const getCountries = async () => {
//   const regions = await axios.get("https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/cities/cities.json");
//   const [rRegions] = await Promise.all([regions]);
//   var rReg = rRegions?.data?.regions?.slice(1); // for
//   return { cities: rReg, states: rReg };
// };

export const getCountries = async () => {
  try {
    // Fetch data from the URL
    const response = await fetch(
      "https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/cities/cities.json"
    );

    // Check if the response is ok (status in the range 200-299)
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Parse the JSON data
    const data = await response.json();

    // Access the regions and slice if needed
    const rReg = data?.regions?.slice(1);

    return { cities: rReg, states: rReg };
  } catch (error) {
    // Handle any errors that occurred during the fetch or data processing
    console.error("Error fetching countries:", error);
    return { cities: [], states: [] }; // Return empty arrays or handle as needed
  }
};

export function createStore(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  const { fida } = getUrls();
  return fetchClass(
    `${fida}/api/createStore`,
    {
      method: "POST",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function updateStore(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  const { fida } = getUrls();
  return fetchClass(
    `${fida}/api/updateStore`,
    {
      method: "PUT",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}

export function APIDeleteStore(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    storeId: params.id,
  };
  delete params.id;
  const { fida } = getUrls();
  return fetchClass(
    `${fida}/api/deleteStore`,
    {
      method: "DELETE",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}

// role apis
export function APIgetRoles(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/getRoles`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function getPermissions(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    application: "stocks.ebuyings",
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/getTenantPermissionsNew`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function createRole(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/createRole`,
    {
      method: "POST",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function updateRole(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    ...params,
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/updateRole`,
    {
      method: "PUT",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function APIDeleteRole(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    _id: params.id,
  };

  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/deleteRole`,
    {
      method: "DELETE",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
// users api
export function APIgetUsers(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  return fetchClass(
    `${getUrls().sso}/api/getUsers`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}
export function APIgetPublicUsers(params) {
  params.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
  };
  return fetchClass(
    `${getUrls().sso}/api/getPublicUser`,
    {
      method: "GET",
      body: { ...params.body },
    },
    {
      ...params.headers,
    },
    false
  );
}

export function addPublicUser(details) {

  const bodyContent = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    firstName: details.firstName || "",
    lastName: details.lastName || null,
    phoneNumber: details.phoneNumber || null,
    email: details.email || null,
    password: details.password || null,
    notes: details.notes || null,
    shippingAddress: {
      city: details.shippingAddress?.city || null,
      state: details.shippingAddress?.state || null,
      zipCode: details.shippingAddress?.zipCode || null,
      address: details.shippingAddress?.address || null,
      country: details.shippingAddress?.country || null,
    },
    tenantId: localStorage.getItem("tenantId") || null,
    platform: "stocks",
  };

  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/registerPublicUser`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: bodyContent,
    },
    {},
    false
  );
}

export function updatePublicUser(details) {

  const bodyContent = {
    _id: details._id,
    notes: details.notes || null,
    password: details.password || null,
    profile: {
      firstName: details.firstName || "",
      lastName: details.lastName || null,
      phoneNumber: details.phoneNumber || null
    },
    shippingAddress: {
      city: details.shippingAddress?.city || null,
      state: details.shippingAddress?.state || null,
      zipCode: details.shippingAddress?.zipCode || null,
      address: details.shippingAddress?.address || null,
      country: details.shippingAddress?.country || null,
    },
    billingAddress: {
      city: details.shippingAddress?.city || null,
      state: details.shippingAddress?.state || null,
      zipCode: details.shippingAddress?.zipCode || null,
      address: details.shippingAddress?.address || null,
      country: details.shippingAddress?.country || null,
    },
  };

  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/updatePublicUserProfileStocks`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: bodyContent,
    },
    {},
    false
  );
}
//
// un assign
export function unassignUserStore(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    storeId: details.storeId,
    _id: details.userId,
  };
  const { fida } = getUrls();
  return fetchClass(
    `${fida}/api/unassignUserStore`,
    {
      method: "POST",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function updateUserProfile(details) {
  details.body = {
    firstName: details.firstName,
    lastName: details.lastName,
    username: details.username,
    mobile: details.mobile,
    emailInfo: details.email,
    roleId: details.roleId,

    skillSets: details.skillSets, // hashed and split skillsets
    jobTitle: details.jobTitle,
    jobResponsibilities: details.jobResponsibilities,
    linkedinProfile: details.linkedinProfile,
    jobExperience: details.jobExperience,
    shiftStartTime: details.shiftStartTime,
    shiftEndTime: details.shiftEndTime,

    _id: details.id,
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/updateUserProfile`,
    {
      method: "PUT",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function addUser(details) {
  const { ...restDetails } = details; // Create a shallow copy without the body property

  const bodyContent = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    usersArray: [{ ...restDetails }],
    platform: "stocks",
  };

  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/importUsers`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: bodyContent,
    },
    {},
    false
  );
}
export function setUserLocations(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    _id: details.userId,
    locations: details.locations,
  };
  const { fida } = getUrls();
  return fetchClass(
    `${fida}/api/setUserLocations`,
    {
      method: "POST",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function updateUserPassword(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    locations: details.locations,
    newPassword: details.password,
    newConfirmPassword: details.newConfirmPassword,
    _id: details.id,
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/updateUserPassword`,
    {
      method: "PUT",
      body: { ...details.body },
    },
    {},
    false
  );
}
export function deleteUser(details) {
  details.body = {
    client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
    client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
    _id: details.id,
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/deleteUser`,
    {
      method: "DELETE",
      body: { ...details.body },
    },
    {
      ...details.headers,
    },
    false
  );
}
export function deletePublicUser(details) {
  details.body = {
    _id: details.id,
  };
  const { sso } = getUrls();
  return fetchClass(
    `${sso}/api/deletePublicUser`,
    {
      method: "DELETE",
      body: { ...details.body },
    },
    {
      ...details.headers,
    },
    false
  );
}
